<template>
  <SkeletonLoading v-if="!servicesDetail" />

  <div class="my-12 lg:my-24 grid grid-cols-2 layout-padding order-last" v-else>
    <div class="col-span-2 lg:col-span-1 lg:hidden flex">
      <div
        class="service-detail-image"
        :style="`background: url(${servicesDetail?.image})`"
      >
      
        <!-- <div class="img-overlay-tw p-8">
          <div class="home-values-border"></div>
        </div> -->
      </div>
    </div>
    <div
      class="
        col-span-2
        lg:col-span-1
        flex flex-col
        justify-center
        lg:mb-0
        my-12
      "
    >
      <div class="relative">
        <div class=" mb-6 lg:mb-16 text-9xl text-safetyBlack">{{ servicesDetail?.title }}</div>
        <div class="services-page-underlay-two uppercase">
          {{ content.services }}
        </div>
      </div>
      <div class="service-detail-text">
        {{ servicesDetail?.description }}
      </div>
      <button
        class="btn-back mt-12 text-primary border p-2 rounded-full px-4 tracking-widest"
        @click="$router.back()"
        v-if="servicesDetail?.title.toLowerCase() != 'steel'"
      >
        <div class="flex items-center">
          <img src="/static/images/arrow.svg" class="back-arrow" />

          {{ content.backToServices }}
        </div>
      </button>
    </div>
    <div class="col-span-2 lg:col-span-1 lg:flex hidden">
      <div
        class="service-detail-image rounded-3xl"
        :style="`background: url(${servicesDetail?.image})`"
      >
        
      </div>
    </div>
  </div>
  <div class=" border-tableBg "></div>
  <div
    class="my-12 lg:my-12 grid grid-cols-12 gap-x-0 lg:gap-x-20 layout-padding"
    v-if="servicesDetail?.id == '1'"
  >
  
    <div class=" col-span-12 mb-6 lg:mb-16 text-6xl text-safetyBlack">
      {{ servicesDetail?.title }} 
    </div>
    
    <div class="w-full col-span-12">
      <ul
        class="  grid lg:grid-cols-5 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-5 gap-x-3 lg:gap-x-5  "
      >
        <li
          @click="selectProduct(product.title)"
          v-for="product in products"
          :key="product"
          
        >
          <div
            class="ProductItem relative rounded-3xl border border-tableBg shadow-sm flex flex-col gap-5 items-center"
            style="width: 100%; height: 300px; overflow: hidden;"
          >
          <div class="product-layer"></div>
            <img
              class="ProductImage w-full h-full object-cover rounded-3xl relative"
              :src="product?.image"
              alt=""
            />
            <span
              class="bg-black bg-opacity-50 text-2xl paragraph tracking-wide text-white font-semibold absolute bottom-0 left-0 text-start py-2 px-2 "
              
           style="text-shadow: 0 0 10px rgba(0,0,0,0.5);" >
              {{ product?.title }}
            </span>
          </div>
        </li>

       
      </ul>
    </div>
    <div class="col-span-12 lg:col-span-9">
    </div>
    <button class="btn-back mt-12 text-primary border p-2 rounded-full px-4 tracking-widest" @click="$router.back()">
      <div class="flex items-center">
        <img src="/static/images/arrow.svg" class="back-arrow" />

        {{ content.backToServices }}
      </div>
    </button>
  </div>

  <TheFooter />
</template>

<script>
import SkeletonLoading from "/src/components/ui/ServiceDetailSkeleton.vue";
// import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore from "swiper";
import { Pagination } from "swiper";
import { EffectFade } from "swiper";
import "swiper/swiper-bundle.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/swiper.min.css";
SwiperCore.use([Pagination, EffectFade]);

export default {
  data() {
    return {
      swiperEvent: null,
      breakpoints: {
        // when window width is >= 320px
        20: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        770: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        980: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      selectedProduct: "finished",
      slideImgs: {
        Billets: [
          { name: "Steel Billet", image: "/static/images/slide/slab-4.jpeg" },
          // { name: "Steel Slab", image: "/static/images/slide/slab-1.png" },
          { name: "Steel Slab", image: "/static/images/slide/slab.png" },
          // { name: "Steel Slab", image: "/static/images/slide/slab-6.jpg" },
          // { name: "Steel Slab", image: "/static/images/slide/slab-1.png" },
        ],
        finished: [
          // { name: "Steel Rebar", image: "/static/images/slide/billet-5.jpg" },
          { name: "Steel Rebar", image: "/static/images/slide/Rebar.jpg" },
          { name: "Wire rod", image: "/static/images/slide/wire-2.jpg" },
          // { name: "Wire rod", image: "/static/images/slide/wire-3.jpg" },
          // { name: "Wire rod", image: "/static/images/slide/wire-4.jpg" },
          // { name: "Wire rod", image: "/static/images/slide/wire.jpg" },
        ],
        MainRawMaterials: [
          { name: "DRI", image: "/static/images/slide/DRI-1.jpg" },
          { name: "HBI", image: "/static/images/slide/HBI-1.png" },
        ],
        FerroAlloys: [
          {
            name: "Ferro Silicon",
            image: "/static/images/slide/Ferrosilicon-2.jpg",
          },

          {
            name: "Ferro Manganese",
            image: "/static/images/slide/ferro-manganese.jpeg",
          },
          {
            name: "Ferrosilicon Manganese",
            image: "/static/images/slide/ferro-silico-manganese.jpg",
          },
          {
            name: "Ferro Chrome",
            image: "/static/images/slide/Fe-Cr.jpg",
          },
        ],

        Coal: [{ name: "Carbon", image: "/static/images/slide/coal-2.jpg" }],
        Refractories: [
          // {
          //   name: "Refractories",
          //   image: "/static/images/slide/Refractories.jpg",
          // },
          {
            name: "Magnesite bricks for steel making furnace",
            // image: "/static/images/slide/Refractories-2.jpg",
            image: "/static/images/slide/Magnesite-Carbon-Bricks-2.jpg",
          },
        ],
        Calcined: [
          { name: "Calcined", image: "/static/images/slide/Calcined.jpg" },
          // { name: "Calcined", image: "/static/images/slide/Calcined-5.jpg" },
        ],
        fluorspar: [
          { name: "Fluorspar", image: "/static/images/slide/Fluorspar-6.jpg" },
        ],
        graphite: [
          {
            name: "Graphite Electrodes ",
            image: "/static/images/slide/ge-2.png",
          },
        ],
      },
    };
  },
  props: ["service"],
  inject: ["content"],
  created() {
    document.getElementById("main-header").classList.add("bg-primary2");
  },
  beforeUnmount() {
    document.getElementById("main-header").classList.remove("bg-primary2");
    this.$store.dispatch("services/clearServiceDetail");
  },
  methods: {
    async loadData() {
      await this.$store.dispatch("services/getServicesDetail", this.service);
      await this.$store.dispatch("products/getProducts");
      await this.$store.dispatch("productType/getProductType");
    },
    setThumbsSwiper(swiper) {
      this.swiperEvent = swiper;
    },
    slideTo(index) {
      this.swiperEvent.slideTo(index + 1, 2000);
    },
    selectProduct(productTitle) {
      this.$router.push({
        name: "ProductType",
        params: { title: productTitle },
      });
    },
    // selectProduct(product) {
    //   this.selectedProduct = "FerroAlloys";
    //   setTimeout(() => {
    //     this.selectedProduct = product;
    //   }, 1);
    // },
  },
  components: {
    SkeletonLoading,
    // Swiper,
    // SwiperSlide,
  },

  computed: {
    servicesDetail() {
      return this.$store.getters["services/servicesDetail"];
    },
    products() {
      return this.$store.getters["products/products"];
    },
    productType() {
      return this.$store.getters["productType/productType"];
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style scoped>

.swiper-container {
  border-radius: 10px;
}
.ProductItem {
  transition: transform 200ms ease-in-out;
  max-height: 90%;
}

.ProductItem:hover {
  transform: scale(1.03);
}
.ProductImage {
  width: 100%;
  object-fit: cover;
  transition: transform 400ms ease-in-out;
}

.ProductImage:hover {
  transform: scale(1.1);
}
</style>
